// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.VerifiableContactDetailModal-module__verifyModal___t3STR{min-width:375px;max-width:375px;background-color:purple}div.VerifiableContactDetailModal-module__verifyModal___t3STR h2{font-size:22px}", ""]);
// Exports
exports.locals = {
	"verifyModal": "VerifiableContactDetailModal-module__verifyModal___t3STR"
};
module.exports = exports;
